// router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import ProductManagement from '../views/ProductManagement.vue';
import AboutDisplay from '../views/AboutDisplay.vue';
import AboutEdit from '../views/About.vue';
import Contact from '../views/Contact.vue';
import ContactUsEdit from '../views/ContactUsEdit.vue';
import Environment from '../views/Environment.vue';
import Quality from '../views/Quality.vue';
import Join from '../views/Join.vue';
import Service from '../views/Service.vue';
import UploadImages from '../views/UploadImages.vue';
import Login from '../views/Login.vue';

const routes = [
  { path: '/', redirect: '/product-management' },
  { path: '/login', component: Login, meta: { requiresAuth: false } },
  { path: '/product-management', component: ProductManagement, meta: { requiresAuth: true } },
  { path: '/upload-images', component: UploadImages, meta: { requiresAuth: true } },
  { path: '/about', component: AboutDisplay, meta: { requiresAuth: true } },
  { path: '/about/edit', component: AboutEdit, meta: { requiresAuth: true } },
  { path: '/contact', component: Contact, meta: { requiresAuth: true } },
  { path: '/contactBig', component: ContactUsEdit, meta: { requiresAuth: true } },
  { path: '/environment', component: Environment, meta: { requiresAuth: true } },
  { path: '/quality', component: Quality, meta: { requiresAuth: true } },
  { path: '/join', component: Join, meta: { requiresAuth: true } },
  { path: '/service', component: Service, meta: { requiresAuth: true } }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');

  // 如果路由需要认证且用户未登录（没有 token），重定向到登录页面
  if (to.meta.requiresAuth && !token) {
    next('/login');
  }
  // 如果用户已登录且尝试访问登录页面，重定向到产品管理页面
  else if (to.path === '/login' && token) {
    next('/product-management');
  }
  // 其他情况正常放行
  else {
    next();
  }
});

export default router;